// Module
var code = `<ng-content></ng-content> <div #anchor></div>`;
// Exports
export default code;